<template>
  <b-modal
    ref="reassignPathologistModal"
    size="xs"
    :title="$t('diagnosis.modals.reassignPathologistModal')"
    centered
    modal-class="reassignPathologistModal"
  >
    <b-row>
      <b-col>
        <div class="mx-3">
          <b-row
            style="width:100%"
            class="m-0"
          >
            <b-col
              cols="12"
              class="pl-0 pr-0"
            >
              <div class="form-label">
                <label>{{ $tc('diagnosis.labels.pathologist', 1) }}</label>
              </div>
              <vt-combo-select
                v-if="laboratoryId"
                v-model="pathologistSelected"
                label="fullName"
                :allow-empty="false"
                :option-loader="getPathologists"
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <vt-loading-button
            qa="reassign-pathologist-modal-apply-button"
            class="btn__outline btn-sm mr-2"
            :params="{ promise: applyChanges }"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { personnelService } from '@/api/resources/personnelService'
import diagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'

export default {
    name: 'ReassignPathologistModal',
    data() {
        return {
            pathologistSelected: null,
            caseGridSelectedRows: [],
            laboratoryId: null
        }
    },
    methods: {
        async applyChanges() {
            const successfullyResponse = await this.updateCaseBatch()
            if (successfullyResponse) {
                this.showToastSuccessGlobal(this.$t('diagnosis.caseUpdated'))
                this.$emit('reloadGrid')
                this.hide()
            }
        },
        async updateCase(laboratoryId, caseId, params) {
            const [err] = await this.toCall(diagnosisCaseService.updateCase(laboratoryId, caseId, params))
            this.updateLoading(false)
            if (err) {
                if (err.response && err.response.data && err.response.data.code === this.$apiExceptions.CONCURRENCY_ERROR) {
                    return this.processBasicConcurrencyConflict(this.$tc('global.case', 1), err, async () => {
                        const originalConcurrencyUpdatedAt = err.response.data.currentConcurrencyUpdatedAt
                        const updatedParams = {
                            pathologistPerId: this.pathologistSelected.id,
                            originalConcurrencyUpdatedAt: originalConcurrencyUpdatedAt
                        }
                        await this.updateCase(laboratoryId, caseId, updatedParams)
                    })
                } else {
                    this.showErrorModalGlobal()
                    return false
                }
            } else {
                return true
            }
        },
        async updateCaseBatch() {
            this.updateLoading(true)
            let successfullyResponse = true
            for (const caseGrid of this.caseGridSelectedRows) {
                const params = { pathologistPerId: this.pathologistSelected.id }
                const caseId = caseGrid.data ? caseGrid.data.casId : caseGrid.casId
                params.originalConcurrencyUpdatedAt = caseGrid.data ? caseGrid.data.originalConcurrencyUpdatedAt : caseGrid.originalConcurrencyUpdatedAt
                successfullyResponse = await this.updateCase(this.laboratoryId, caseId, params)
            }
            this.updateLoading(false)
            return successfullyResponse
        },
        show(selectedCases, laboratoryId) {
            this.initializeData(selectedCases, laboratoryId)
            this.$refs.reassignPathologistModal.show()
        },
        initializeData(selectedCases, laboratoryId) {
            this.laboratoryId = laboratoryId
            this.caseGridSelectedRows = selectedCases
            if (this.caseGridSelectedRows.length === 1) {
                this.setCurrentPathologist()
            }
        },
        setCurrentPathologist() {
            this.pathologistSelected = this.caseGridSelectedRows.map(caseData => caseData.pathologist)[0]
        },
        hide() {
            this.$refs.reassignPathologistModal.hide()
        },
        getPathologists() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.laboratoryId, CommonResponsibilityCodeEnum.PATHOLOGIST)
        }
    }
}
</script>

<style lang="scss" scoped>
  .responsible-card span{
    font-size: font-size(small);
  }

  .responsible-card i{
    font-size: 25px;
  }

  .responsible-card{
    text-align: justify;
    line-height: 16px;
  }

</style>
